import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import Menu from './ResourcesMenu';
import {RESOURCE_PROPS} from '../../../models/appModels';
import * as resourcesActions from '../../../actions/resourcesActions';
import * as actionTypes from '../../../actions/actionTypes';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as objectConstants from '../../../constants/objectConstants';
import {getScreenComponentByType} from '../../../helpers/componentHelper';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import * as localeStorage from '../../../localStorage/localStorage';


class Resources extends React.Component {

    constructor(props, context) {
        super(props, context);

        let bite_id = appHelper.getBiteByScreenId(this.props.trackingData.lesson_location);
        this.state = {
            lang: this.props.lang,
            bite: appHelper.getBiteById(bite_id),
            resources: localeStorage.resources,
            activeResource: this.props.activeResourcesId !== 0 && appHelper.isDefined(appHelper.getArrayObjectByKey(localeStorage.resources, "screen_id", this.props.activeResourcesId).screen_id) ? appHelper.getArrayObjectByKey(localeStorage.resources, "screen_id", this.props.activeResourcesId) : localeStorage.resources[0],
            activeResourcesId: this.props.activeResourcesId,
            resources_screen_type: {},
            callbacks: {},
            tabbableElements: [],
            doSetTabbableElements: false,
            doSetIntitialFocus: false,
            initalFocusSet: false,
            isDialog: true,
            elementInterval: {},
            guid: dataHelper.createGuid(),
            back_label: appHelper.getLocaleString("back_label"),
            next_label: appHelper.getLocaleString("next_label")
        };

        this.getResources = this.getResources.bind(this);
        this.getResourcesScreenType = this.getResourcesScreenType.bind(this);
        this.setResourcesStatus = this.setResourcesStatus.bind(this);
        this.setResourcesAnimation = this.setResourcesAnimation.bind(this);
        this.showResources = this.showResources.bind(this);
        this.hideResources = this.hideResources.bind(this);
        this.closeResources = this.closeResources.bind(this);
        this.getClass = this.getClass.bind(this);
        this.setActiveResource = this.setActiveResource.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.showHeader = this.showHeader.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.setToolTip = this.setToolTip.bind(this);
        this.getPreviousBtnClass = this.getPreviousBtnClass.bind(this);
        this.getNextBtnClass = this.getNextBtnClass.bind(this);
        this.getPreviousResource = this.getPreviousResource.bind(this);
        this.getNextResource = this.getNextResource.bind(this);
        this.setAccessibleExit = this.setAccessibleExit.bind(this);
        this.keyboardGetPreviousResource = this.keyboardGetPreviousResource.bind(this);
        this.keyboardGetNextResource = this.keyboardGetNextResource.bind(this);
        this.setTabbableElements = this.setTabbableElements.bind(this);
        this.setInitialFocus = this.setInitialFocus.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.updateTabbableElements = this.updateTabbableElements.bind(this);
        this.setElementInterval = this.setElementInterval.bind(this);
    }

    componentDidMount() {
        window.addEventListener("keydown", this.onKeyDown);
        window.addEventListener("keyup", this.onKeyUp);
        this.updateTabbableElements();
        this.setCallbacks();
        this.setResourcesAnimation();
        this.setElementInterval();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,

                back_label: appHelper.getLocaleString("back_label"),
                next_label: appHelper.getLocaleString("next_label")
            });
        }

    }

    componentDidUpdate() {
        this.setResourcesAnimation();
        if (typeof this.state.resources_screen_type.component === 'undefined') {
            this.getResources();
        }
        if (this.state.doSetTabbableElements) {
            this.setTabbableElements();
        }

        if (this.state.doSetIntitialFocus && !this.state.initalFocusSet) {
            this.setInitialFocus();
        }


        //this.setTabbableElements();
    }

    componentWillUnmount() {
        window.removeEventListener("keyup", this.onKeyUp);
        clearInterval(this.state.elementInterval);
    }

    setElementInterval() {
        let interval = setInterval(this.setTabbableElements, 2000);
        this.setState({elementInterval: interval});
    }


    getPreviousBtnClass() {
        let resource = appHelper.getPreviousResource(this.state.activeResource);
        return !appHelper.isDefined(resource.screen_id) ? "disabled" : "";
    }

    getNextBtnClass() {
        let resource = appHelper.getNextResource(this.state.activeResource);
        return !appHelper.isDefined(resource.screen_id) ? "disabled" : "";
    }

    getPreviousResource() {
        let resource = appHelper.getPreviousResource(this.state.activeResource);
        if (appHelper.isDefined(resource.screen_id)) {
            this.setActiveResource(resource);
        }
    }

    getNextResource() {
        let resource = appHelper.getNextResource(this.state.activeResource);
        if (appHelper.isDefined(resource.screen_id)) {
            this.setActiveResource(resource);
        }
    }

    setCallbacks() {
        this.setState({
            callbacks: Object.assign({}, this.state.callbacks, {
                showHeader: this.showHeader,
                getBiteId: this.getBiteId,
                setToolTip: this.setToolTip
            })
        });
    }

    showHeader() {
    }

    getBiteId() {
        return appHelper.getBiteByScreenId(this.props.trackingData.lesson_location);
    }

    setToolTip() {
    }

    getResources() {
        //let resources = appHelper.getResources();
        this.getResourcesScreenType();
    }

    getResourcesScreenType() {
        let screenType = Object.assign({}, getScreenComponentByType(this.state.activeResource.screen_type));
        this.setState({
            resources_screen_type: Object.assign({}, screenType),
        });
    }

    setResourcesAnimation() {
        switch (this.props.displayResources) {
            case actionTypes.STATUS_OPENING:
                this.showResources();
                break;
            case actionTypes.STATUS_CLOSING:
                this.hideResources();
                break;
            default:
                break;
        }
    }

    setResourcesStatus() {
        let resourceProps = Object.assign({}, RESOURCE_PROPS, {
            activeResourcesId: 0,
            sourceId: ""
        });

        switch (this.props.displayResources) {
            case actionTypes.STATUS_OPENING:
                this.props.actions.setResourcesDisplay(actionTypes.STATUS_OPEN);
                this.setState({doSetTabbableElements: true});
                break;
            case actionTypes.STATUS_CLOSING:
                this.props.actions.setResourcesDisplay(actionTypes.STATUS_CLOSED);
                this.props.actions.setResourcesProps(resourceProps);
                break;
            default:
                break;
        }
    }

    showResources() {
        let resourcesPanel = this.refs['resources'];
        //TweenLite.set(mainMenuPanel, {height: "auto", opacity: 1});
        TweenLite.to(resourcesPanel, objectConstants.DIALOG_DURATION, {
            opacity: 1,
            delay: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.setResourcesStatus);
    }

    hideResources() {
        this.getClass();
        let resourcesPanel = this.refs['resources'];
        //TweenLite.set(mainMenuPanel, {height: 0, opacity: 0});
        TweenLite.to(resourcesPanel, objectConstants.DIALOG_DURATION, {

            opacity: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.setResourcesStatus);
    }

    closeResources() {
        if (appHelper.isDefined(this.props.sourceId) && this.props.sourceId.length > 0) {
            let focusEl = document.getElementById(this.props.sourceId);
            if (appHelper.isDefined(focusEl)) {
                focusEl.focus();
            } else {
                document.getElementById("resourcesBtn").focus();
            }
        } else {
            document.getElementById("resourcesBtn").focus();
        }
        this.props.actions.setResourcesDisplay(actionTypes.STATUS_CLOSING);
    }

    getClass() {
        if (this.props.displayResources === actionTypes.STATUS_OPEN) {
            return "dialog-open";
        } else {
            return "dialog-closed";
        }
    }

    setActiveResource(resource) {
        this.setState({
            activeResource: Object.assign({}, resource),
            resources_screen_type: Object.assign({}, {}),

        });
        //let setTabbableElements = this.setTabbableElements;

    }

    setAccessibleExit(event) {
        if (event.which === keyboardConstants.ESCAPE_KEY) {
            event.preventDefault();
            this.closeResources();
        }
    }

    keyboardGetPreviousResource(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.getPreviousResource();
        }
    }

    keyboardGetNextResource(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.getNextResource();
        }
    }

    setTabbableElements() {
        //console.log(`setTabbableElements`);
        let dialog = this.refs[`resources`];
        let tabbableElements = dataHelper.getAllTabbableElements(dialog);
        this.setState({
            doSetTabbableElements: false,
            tabbableElements: Object.assign([], tabbableElements),
            doSetIntitialFocus: !this.state.initalFocusSet
        });

    }

    setInitialFocus() {
        let focusTarget = this.state.tabbableElements[1];
        this.setState({initalFocusSet: true});
        setTimeout(function () {
            focusTarget.focus();
        }, 1000);
    }

    updateTabbableElements() {
        this.setTabbableElements();
    }

    onKeyDown(event) {
        let shiftPressed = this.state.shiftPressed;
        let tabPressed = this.state.tabPressed;
        if (event.which === keyboardConstants.ESCAPE_KEY) {

            event.preventDefault();
            this.closeResources();
        }

        if (event.which === keyboardConstants.TAB_KEY) {
            tabPressed = true;
            this.setState({
                tabPressed: tabPressed
            });
        }

        if (event.which === keyboardConstants.SHIFT_KEY) {
            shiftPressed = true;
            this.setState({
                shiftPressed: shiftPressed
            });
        }
    }

    onKeyUp(event) {
        let activeItem = document.activeElement;
        let activeItemId = activeItem.id;

        if (this.state.tabbableElements.length > 0) {
            if (activeItemId === this.state.tabbableElements[0].id) {
                //go to last
                this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
            } else if (activeItemId === this.state.tabbableElements[this.state.tabbableElements.length - 1].id) {
                this.state.tabbableElements[1].focus();
            }
        }
        this.setState({
            tabPressed: false,
            shiftPressed: false
        });
    }

    render() {
        let Component = this.state.resources_screen_type.resourcesComponent;
        return (

            <div className={`dialog-page resources ${this.getClass()}`} ref={`resources`} role="dialog"
                 aria-modal={this.state.isDialog} aria-labelledby="resources">
                <div id={`firstTabIndex_resources_${this.state.guid}`} tabIndex="0" role="button"/>
                <div className="content-dialog resources">
                    <div className="dialog-header guroo-dialog-header">
                        <div className="resources-header-layout">
                            <div className="flex-item flex-3">
                                <Menu menuData={this.state.resources}
                                      currentSelection={this.state.activeResource}
                                      onMenuSelect={this.setActiveResource}
                                      idKey="screen_id"
                                      labelKey="label"/>
                            </div>
                            <div className="flex-item flex-1 text-right">
                                <ul className="resources-nav">
                                    <li className={`resources-nav-item ${this.getPreviousBtnClass()}`}
                                        role="presentation">
                                        <div className="resources-back-btn" role="link" tabIndex="0"
                                             onClick={this.getPreviousResource}
                                             onKeyDown={this.keyboardGetPreviousResource}
                                             aria-disabled={appHelper.isDefined(appHelper.getPreviousResource(this.state.activeResource))}>
                                            {this.state.back_label}
                                        </div>
                                    </li>
                                    <li className={`resources-nav-item ${this.getNextBtnClass()}`} role="presentation">
                                        <div className="resources-next-btn" role="link" tabIndex="0"
                                             onClick={this.getNextResource} onKeyDown={this.keyboardGetNextResource}
                                             aria-disabled={appHelper.isDefined(appHelper.getNextResource(this.state.activeResource))}>
                                            {this.state.next_label}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="dialog-body" ref={`resources_feed`}>
                        <div className="resources-content">
                            {appHelper.isDefined(Component)
                                ?
                                <Component screen={this.state.activeResource} biteCallbacks={this.state.callbacks}/>
                                :
                                null
                            }
                        </div>
                    </div>
                </div>
                <div id={`lastTabIndex_resources_${this.state.guid}`} tabIndex="0" role="button"/>
            </div>
        );
    }
}

Resources.propTypes = {
    children: React.PropTypes.node,
    displayResources: PropTypes.string.isRequired,
    activeResourcesId: PropTypes.number,
    sourceId: PropTypes.string,
    trackingData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        displayResources: state.displayResources,
        activeResourcesId: state.resourceProps.activeResourcesId,
        sourceId: state.resourceProps.sourceId,
        trackingData: state.trackingData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, resourcesActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Resources);


/** WEBPACK FOOTER **
 ** ./src/components/dialogs/resources/Resources.js
 **/